import React from "react";
import BioCard from "./BioCard";
import TotalCard from "./TotalCard";

const HeaderSection = ({ data }) => {
  const driver = data.driver || {};
  const totals = data.totals || {};

  return (
    <section className="grid grid-cols-1 lg:grid-cols-4 gap-6">
      <BioCard driver={driver} totalGroupedTrips={totals.grouped_trips || 0} />

      <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-6">
        <TotalCard label="Total Payout" value={totals.payout} accent="emerald" />
        <TotalCard
          label="Total Deductions"
          value={totals.deductions}
          accent="red"
          subtext={totals.deductions > 0 ? null : "Zero penalties incurred"}
        />
        <TotalCard
          label="Bonuses"
          value={totals.bonuses}
          accent="purple"
          subtext={totals.bonuses > 0 ? null : "On-Time eligible"}
        />
      </div>
    </section>
  );
};

export default HeaderSection;
